var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagFilled = function SvgTagFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.81 3v2.803c0 .319.125.624.35.85l3.6 3.6a1.2 1.2 0 0 0 1.697 0l2.803-2.804a1.2 1.2 0 0 0 0-1.697l-3.6-3.6a1.2 1.2 0 0 0-.847-.352H3.01c-.662 0-1.2.538-1.2 1.2m2.1.3a.6.6 0 1 1 0 1.2.6.6 0 0 1 0-1.2"
  })));
};
export default SvgTagFilled;